"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgLetterSpacing01 = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M4 3a1 1 0 0 0-2 0v18a1 1 0 1 0 2 0V3ZM22 3a1 1 0 1 0-2 0v18a1 1 0 1 0 2 0V3Z", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.462 14 7.91 17.414a1 1 0 0 1-1.82-.828l4.286-9.43a8.36 8.36 0 0 1 .306-.63c.094-.165.288-.482.655-.663a1.5 1.5 0 0 1 1.326 0c.367.18.56.498.655.663.1.177.203.404.306.63l4.286 9.43a1 1 0 0 1-1.82.828L14.538 14H9.462Zm4.167-2H10.37L12 8.417 13.629 12Z", fill: "currentColor" })] }))); };
exports.default = SvgLetterSpacing01;
